/**
 * Datum-Prüfung vor dem Senden (#92, Paul 26.10.2026): Datum in Betreff/Text
 * gegen den Termin des Falls, Wochentag gegen Datum, „zwischen 16 Uhr" ohne
 * zweite Uhrzeit. NUR Hinweise — gesendet werden darf immer.
 *
 * Fail-open: ist die Prüfung nicht erreichbar, gibt es keine Hinweise und der
 * Versand läuft wie bisher.
 */
export async function datumHinweise(emailId: number | string, subject: string, body: string): Promise<string[]> {
  try {
    const r = await fetch(`/api/v1/emails/${emailId}/sende-pruefung`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ subject, body }),
    })
    if (!r.ok) return []
    const j = await r.json() as { hinweise?: { text?: string }[] }
    return (j.hinweise || []).map((h) => h.text || "").filter(Boolean)
  } catch {
    return []
  }
}
